var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 7,
    viewBox: "0 0 18 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6975 2.44211H1.1405C0.513227 2.44211 0 2.92004 0 3.50417C0 4.08831 0.513227 4.56624 1.1405 4.56624H13.6975V6.46734C13.6975 6.94527 14.3133 7.17892 14.6669 6.83906L17.8375 3.8759C18.0542 3.66348 18.0542 3.33424 17.8375 3.12183L14.6669 0.158667C14.3133 -0.181194 13.6975 0.0630805 13.6975 0.530389V2.44211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.eb111862a1b5bdc8890c61ab4d288ab3.svg";
export { ForwardRef as ReactComponent };